import React, { useState, useContext } from "react";
import { NumericFormat } from "react-number-format";

// context
import { DispatchContext } from "bodycodi/cmap/app/components/common/context";

type Props = {
  type: "currency" | "point";
  disabled: boolean;
  onChange: any;
  maxPrice: any;
};

const Input = ({ type, disabled, onChange, maxPrice }: Props) => {
  const [value, setValue] = useState<number>(0);
  const { dispatch } = useContext(DispatchContext);

  const isAllowed = (values: any) => {
    const { floatValue, formattedValue } = values;
    return formattedValue === "" || floatValue <= maxPrice;
  };

  const handleBlur = (e: any) => {
    if (value) {
      if (value % 100 === 0) {
        onChange(value);
      } else {
        dispatch({
          type: "ALERT_SETTING",
          data: {
            alert: true,
            cancleYn: false,
            header: "할인 금액",
            body: `할인 금액은 100원 단위로만 \n사용 할 수 있습니다.`,
            closeAlert: () => {
              setValue(0);
              return;
            },
          },
        });
      }
    } else {
      setValue(0);
      onChange(0);
    }
  };

  return (
    <div className="input">
      <div className={`input-wrapper ${disabled ? "disabled" : ""}`}>
        <NumericFormat
          type="tel"
          className={type}
          onBlur={handleBlur}
          thousandSeparator={","}
          value={value}
          onValueChange={(val: any) => setValue(val.floatValue)}
          allowLeadingZeros={false}
          allowNegative={false}
          disabled={disabled}
          isAllowed={isAllowed}
          suffix={!disabled && value ? "-" : ""}
        />
        <span className={`${type} ${disabled ? "disabled" : ""}`}>원</span>
      </div>
    </div>
  );
};

export default Input;
